module.exports = __webpack_public_path__ + "static/media/10.5e1a5c00.jpg";